/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CameraIcon = /*#__PURE__*/ createSvgIcon(
  'CameraIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8.75a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zM6.25 11.5a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM.5 4.5A.5.5 0 011 4h2a.5.5 0 010 1H1a.5.5 0 01-.5-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.397 3.469A2.232 2.232 0 018.24 2.5h3.909a2.285 2.285 0 011.832.964l.018.027L15.304 6H19.5v11.5H.5V6h4.23l1.667-2.531zm.828.56L5.27 7H1.5v9.5h17V7h-3.804l-1.553-2.988a1.288 1.288 0 00-1.008-.512H8.24c-.407 0-.79.2-1.015.528z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CameraIcon;
